(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["testimonials-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.testimonials-card__video-toggle').forEach((videoToggle) => {
        const video = videoToggle.closest('article').querySelector('video');
        if (!video) return;

        function setState(playing) {
            videoToggle.dataset.state = playing ? 'playing' : 'paused';
        }

        function pauseOtherVideos() {
            const otherVideos = document.querySelectorAll('.testimonials-card__video-toggle[data-state="playing"]');
            if (!otherVideos.length) return;

            otherVideos.forEach((otherVideo) => {
                otherVideo.closest('article').querySelector('video').pause();
                otherVideo.setAttribute('data-state', 'paused');
            });
        }

        function toggle() {
            if (video.paused) {
                pauseOtherVideos();
                video.play();
                setState(true);
            } else {
                video.pause();
                setState(false);
            }
        }

        videoToggle.addEventListener('click', toggle);
        video.addEventListener('click', toggle);
        video.addEventListener('ended', () => setState(false));
    });
  } catch(e) { console.error(e); }
})();

})();
